const misc = {
  notFound: {
    title: "找不到頁面",
    message: "您查找的頁面不存在或已被移動。",
    backToHome: "返回首頁",
    error404: "404",
  },
};

export default misc;
